import * as React from "react";
const SvgNavMenuActive = props => <svg xmlns="http://www.w3.org/2000/svg" width={54} height={4} fill="none" viewBox="0 0 54 4" {...props}><path fill="#9747FF" d="M0 0h54a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4" /></svg>;
export default SvgNavMenuActive;